import React, { useEffect, useMemo, useRef, useState } from 'react'
import SelectEmployeeOption from './SelectComponent'
import { debounce } from 'lodash/function'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import {
    GET_EMPLOYEE_ACCOUNT,
    GET_EMPLOYEE_HRM
} from '../../../api/hrm/personel/record/employeeGql'
import { usedGraphqlLazyQuery } from '../../graphql/graphql-client'
import PropTypes from 'prop-types'
import { useMainAppContext } from '../../../hooks/useMainAppContext'

const SelectEmployee = (props) => {
    const { employeeCurrent, placeholder, notFoundContent } = props
    const { t } = useTranslation()
    const [employees, setEmployees] = useState([])
    const [filterEmployee, setFilterEmployee] = useState([])
    const [value, setValue] = useState({ value: props.value })

    const { employeeHrm } = useMainAppContext()

    function initialOptions() {
        setEmployees(employeeHrm)
    }

    useEffect(() => {
        const newData = []
        employees?.forEach((item) => {
            if (item?.screenName) {
                newData.push(item)
            } else {
                if (
                    value?.value === item?.id ||
                    employeeCurrent === item?.id ||
                    (value?.value instanceof Array &&
                        value?.value?.includes(item?.id))
                )
                    newData.push(item)
            }
        })
        setFilterEmployee(newData)
    }, [value, employees?.length])

    useEffect(() => {
        setValue({
            value: props.value
        })
    }, [props.value])

    useEffect(() => {
        initialOptions()
    }, [employeeCurrent])

    const handleSearch = (search) => {
        const filterData = employees?.filter((item) => {
            return (item?.screenName && (
                    item?.name?.toLowerCase().includes(search.toLowerCase()) ||
                    item?.screenName?.toLowerCase().includes(search.toLowerCase()))
            )
        })

        setFilterEmployee(filterData)
    }

    function NotFoundContent(props) {
        return (
            <div className={'text-center text-black py-[30px] px-[40px]'}>
                <p className={'mb-2 font-[600] leading-[24px]'}>
                    {t('tnp.components.common.text2')}
                </p>
                <p className={'text-[14px] font-[400] leading-[20px]'}>
                    {t('tnp.components.common.text3')}
                </p>
            </div>
        )
    }

    return (
        <SelectEmployeeOption
            data={filterEmployee}
            placeholder={placeholder}
            notFoundContent={notFoundContent || <NotFoundContent />}
            filterOption={false}
            onSearch={handleSearch}
            {...props}
        />
    )
}

SelectEmployee.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    employeeCurrent: PropTypes.number,
    placeholder: PropTypes.string,
    notFoundContent: PropTypes.node
}
export default SelectEmployee
